import fieldMixin from '@maison/mixins/fieldMixin';
import TextField from '@maison/components/form/fields/TextField.vue';

export default {
  components: {
    TextField,
  },

  mixins: [fieldMixin],

  data() {
    return {};
  },

  computed: {
    helperSamples() {
      return [
        { number: 1, sample: '<b>18/1164RD21</b>' },
        { number: 2, sample: '<b>7424CP</b>' },
        { number: 3, sample: '<b>A123YZT</b>' },
      ];
    },

    locateYourBoutiqueLink() {
      return window.route('boutiques');
    },
  },
};
